<div class="card m-0 theme-card">
    <a class="card-header" aria-expanded="true">
        <h4 class="pr-0">
            Row Data View

            <span class="pull-right mr-2 close-icon" (click)="close()"><i class="fa fa-times"></i> </span>
        </h4>
    </a>

    <div class="card-body col-md-12 col-sm-12">
        <form [formGroup]="dynamicForm">
            <div class="row">
                <div *ngFor="let field of formFields" class="mb-1 col-md-6 col-sm-12">
                    <label class="fw-bold wrap-text">{{ field.field_name }}</label>

                    <!-- TEXT -->
                    <mat-form-field appearance="outline" class="w-100" *ngIf="field.inputType === 'text'">
                        <input matInput [formControlName]="field.data_field_name">
                    </mat-form-field>

                    <!-- SELECT -->
                    <mat-form-field appearance="outline" class="w-100" *ngIf="field.inputType === 'select'">
                        <mat-select [formControlName]="field.data_field_name">
                            <mat-option *ngFor="let opt of field.options" [value]="opt">
                                {{ opt }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>

    </div>

    <div class="card-actions d-flex justify-content-between p-2">
        <div class="du-btn-group m-0">
            <div class="w-100 mx-auto">
                <!-- <button fullWidth class="custom-btn custom-mat-btn du-save-btn" (click)="updateRow()"
                    *ngIf="(mode === 'editMode')"
                    [disabled]="(form.status === 'INVALID')|| (!dataTouched)|| !rolePermissions.CanModify" title="Save">
                    <mat-icon class="custom-icon">save</mat-icon>
                </button> -->
                <button fullWidth class="custom-btn custom-mat-btn du-nextPrev-btn" title="Previous"
                    (click)="getRecord('previous')" *ngIf="showPreviousNext" [disabled]="isPreviousDisabled">
                    <mat-icon class="custom-icon2">chevron_left</mat-icon>
                </button>

                <button fullWidth class="custom-btn custom-mat-btn du-nextPrev-btn" title="Next"
                    (click)="getRecord('next')" *ngIf="showPreviousNext" [disabled]="isNextDisabled">
                    <mat-icon class="custom-icon2">chevron_right</mat-icon>
                </button>


            </div>
        </div>
        <div>
            <button mat-raised-button color="primary" (click)="submit()">
                Update
            </button>
        </div>
    </div>
</div>